export default __webpack_public_path__ + "static/media/webcamButton.bde806a2.svg";